import { yupResolver } from "@hookform/resolvers/yup";
import { Box, Modal } from "@mui/material";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import CommonButton from "../../../common/components/Buttons/CommonButton";
import InputField from "../../../common/components/FormFields/InputField";
import { CloseModalIcon } from "../../../common/components/assets/commonassets/CommonAssets";
import CommonBackDrop from "../../../common/components/CommonBackDrop/CommonBackDrop";
import {
  errorAlert,
  successAlert,
} from "../../../common/components/Toasts/CustomToasts";
import { useState } from "react";
import { saveTemplateMaster } from "../../services/emrTemplateServices/EMRTemplateServices";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 2,
  borderRadius: "8px",
};

const schema = yup.object().shape({
  templateName: yup.string().trim().required("Template name is required"),
});

const TemplateNameModal = ({
  openModal,
  setOpenModal,
  selectedId,
  selectedRow,
  selectedFieldId,
  setSelectedFieldId,
  getHopi,
  getGeneralExaminations,
  getRS,
  getCVS,
  getCNS,
  getPA,
  getOther
}) => {
  const {
    control,
    handleSubmit,
    reset,
    watch,
    formState: { errors },
  } = useForm({
    defaultValues: {
      templateName: "",
    },
    resolver: yupResolver(schema),
  });
  //   const getUserInfo = JSON.parse(localStorage?.getItem("loggedUser"));

  const templateName = watch("templateName");
  const [openBackDrop, setOpenBackdrop] = useState(false);
  const onSubmit = () => {
    const obj = {
      templateName: templateName,
      templateFieldId: selectedFieldId ? selectedFieldId : null,
      description:
        selectedFieldId === 1
          ? getHopi
          : selectedFieldId === 3
            ? getGeneralExaminations
            : "",
      doctorId: selectedRow?.["Doctor Id"] ? selectedRow?.["Doctor Id"] : null,
      id: selectedId !== null ? selectedId : null,
      rs: getRS !== "" ? getRS : "",
      cvs: getCVS !== "" ? getCVS : "",
      cns: getCNS !== "" ? getCNS : "",
      other: getOther !== "" ? getOther : ""
    };
    setOpenBackdrop(true);

    console.log(obj, "objobjobjobjobjobjobjobjobj");
    saveTemplateMaster(obj)
      .then((response) => response.data)
      .then((res) => {
        if (res.statusCode === 201 || res.statusCode === 200) {
          setOpenModal(false);
          // populateTable();
          successAlert(res?.message);
          reset();
          setOpenBackdrop(false);
          setSelectedFieldId(null);
        }
      })
      .catch((error) => {
        // console.log("error", error);
        setOpenModal(false);
        errorAlert(error?.message);
        setOpenBackdrop(false);
      });
  };

  return (
    <Modal open={openModal}>
      <Box sx={style}>
        <div className="flex justify-between items-center mb-2">
          <h2 className="font-semibold">Template Name</h2>

          <div
            className="cursor-pointer"
            onClick={() => {
              reset();
              setOpenModal(false);
              setSelectedFieldId(null);
            }}
          >
            <CloseModalIcon />
          </div>
        </div>
        <form onSubmit={handleSubmit(onSubmit)}>
          <InputField
            label="Template Name*"
            name="templateName"
            control={control}
            error={errors.templateName}
          />

          <div className="flex justify-end gap-2 mt-4">
            <CommonButton
              label="Reset"
              type="button"
              onClick={() => reset()}
              className="resetButton px-6 py-2 border border-red-500 text-red-500"
            />

            <CommonButton
              label="Save"
              type="submit"
              className="px-6 py-2 bg-green-700 text-white text-base"
            />
          </div>
          {openBackDrop && <CommonBackDrop openBackdrop={openBackDrop} />}
        </form>
      </Box>
    </Modal>
  );
};

export default TemplateNameModal;
